import { render, staticRenderFns } from "./SearchGalleryElastic.vue?vue&type=template&id=da2229ee&scoped=true"
import script from "./SearchGalleryElastic.vue?vue&type=script&lang=js"
export * from "./SearchGalleryElastic.vue?vue&type=script&lang=js"
import style0 from "./SearchGalleryElastic.vue?vue&type=style&index=0&id=da2229ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2229ee",
  null
  
)

export default component.exports